import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { useCallback } from 'react';

/** Actions on the transcription word selection menu. */
export type TranscriptionMenuAction = 'start_selection' | 'end_selection' | 'clear';

/**
 * PostHog capture for transcription word menu clicks.
 * Events are sent as `logger:transcription_menu_action`.
 */
export function useTranscriptionMenuCapture() {
  const capture = usePostHogCapture({ domain: 'logger' });

  return useCallback(
    (action: TranscriptionMenuAction) => {
      capture('transcription_menu_action', { action });
    },
    [capture],
  );
}
